/**
 * AI Analyst copy: answer parts (tables, charts, snapshot card, sources, verify links).
 * Ported verbatim from VentaHub (`pages/AiAnalyst/components/parts.tsx`,
 * `CompactTable.tsx`, `AnswerExtras.tsx`); wired under `aiAnalyst` in `en.ts`,
 * so these are `aiAnalyst.parts.*`.
 */
export const aiAnalystParts = {
  // Fallback card titles when the analyst gave none.
  result: 'Result',
  chart: 'Chart',
  // The table card's meta: `n` is the formatted figure, `count` picks the plural.
  rows_one: '{{n}} row',
  rows_other: '{{n}} rows',
  someRows_one: '{{shown}} of {{n}} row',
  someRows_other: '{{shown}} of {{n}} rows',
  someRowsCapped_one: '{{shown}} of {{n}}+ row',
  someRowsCapped_other: '{{shown}} of {{n}}+ rows',
  firstRows_one: 'Showing the first {{n}} row. Export for the full result.',
  firstRows_other: 'Showing the first {{n}} rows. Export for the full result.',
  firstRowsCapped_one: 'Showing the first {{n}} row (result capped). Export for the full result.',
  firstRowsCapped_other:
    'Showing the first {{n}} rows (result capped). Export for the full result.',
  noRows: 'No rows.',
  copyTable: 'Copy table',
  copied: 'Copied. Paste into Excel or Sheets',
  copyFailed: "Couldn't copy",
  export: 'Export',
  exportTooltip: 'Export full result',
  downloadCsv: 'Download CSV',
  downloadExcel: 'Download Excel',
  exportFailed: 'Export failed. Please try again.',
  showAsTable: 'Show as table',
  showAsChart: 'Show as chart',
  snapshot: {
    title: 'Business health snapshot',
    insights: 'Insights ({{n}})',
    filterByArea: 'Filter insights by area',
    all: 'All',
    confidence: 'Confidence: {{level}}',
    impact: 'Impact:',
    doNext: 'Do next:',
    showEvidence: 'Show evidence',
    hideEvidence: 'Hide evidence',
    evidenceFailed: 'The evidence could not be loaded.',
    evidenceFirst_one: 'First {{shown}} of {{n}} row.',
    evidenceFirst_other: 'First {{shown}} of {{n}} rows.',
  },
  sources: {
    howCalculated: 'How this was calculated',
    outOfDate: 'Data may be out of date',
    staleEntry: '{{domain}} · {{marketplace}}: latest {{day}}',
    freshEntry: '{{domain}} · {{marketplace}}: data up to {{day}}',
    staleFreshEntry: '{{domain}} · {{marketplace}}: data up to {{day}} (more than a day old)',
    scope: 'Scope',
    period: 'Period',
    definitions: 'Definitions',
    dataUsed: 'Data used',
    assumptions: 'Assumptions',
    freshness: 'Data freshness',
    caveats: 'Caveats',
  },
  // VentaWiz addition: the pages where the reader can check the numbers.
  verifyInVentaWiz: 'Verify in VentaWiz',
  closestView: 'Closest view',
  closestViewTooltip:
    'This page shows more than the answer: one of its filters cannot be applied here.',
} as const
